export default {
  unavailable: {
    title: 'Selvbetjent partneradgang er begrænset',
    description:
      'Dette afsnit er ikke tilgængeligt for partnere med selvbetjent onboarding. Kontakt din kontoansvarlige, hvis du har brug for det.',
  },
};
